import React from "react";
import Loadable from "../../react-loadable";
import middleware from "../../middleware";
import WeaCustomNew from "../wea-custom-new";
import "./public/index.less";

const WeaEcodeUpload = Loadable({
  loader: () => import("./public"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

class EcodeUpload extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <WeaCustomNew type="ecodeUpload" {...this.props}>
        <WeaEcodeUpload {...this.props} />
      </WeaCustomNew>
    );
  }
}

const Com = middleware(EcodeUpload, "WeaEcodeUpload");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-ecode-upload/index.js